export default "./images/EN75.jpg";